module.exports = __webpack_public_path__ + "static/img/List_Icon.3a96999.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/List_Icon.png
// module id = 1095
// module chunks = 21